import { configForCurrentEnv } from "../../config/environment"
import { UpdateUserInput } from "../../rpcs/dist/UserRPC"
import { ImageTransform } from "./image-transform-ifneeded"
import { IMAGE_UPLOAD_PATH } from "../../config/imageUploadPath"

export interface IUploadImage {
  md5: string
  url: {
    small: string
    medium: string
    large: string
    square: string
  }
}

export const MAXIMUM_DIMENSION = 1000
export const SUPPORTED_IMAGE_MIME_TYPE = [
  "image/jpeg",
  "image/png",
  "image/gif",
]

export const InputImageErrorCheck = async (
  files: FileList | null,
): Promise<File> => {
  if (!files || !files[0]) {
    return Promise.reject({
      code: -9997,
      message: "画像ファイルを選択してください",
    })
  }

  const file = files[0]

  if (!SUPPORTED_IMAGE_MIME_TYPE.includes(file.type)) {
    return Promise.reject({
      code: -9998,
      message: "対応していないファイル形式です",
    })
  }

  return file
}

export const ImageUpload = (base64string: string): Promise<IUploadImage> => {
  return new Promise((resolved, rejected) => {
    const xhr = new XMLHttpRequest()
    xhr.open(
      "POST",
      `${configForCurrentEnv.endpoints.api}${IMAGE_UPLOAD_PATH}`,
      true,
    )
    xhr.setRequestHeader("Content-Type", "text/plain")
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          return resolved(JSON.parse(xhr.responseText))
        } else {
          return rejected({
            code: -9996,
            message: `アップロードに失敗しました。\n(ステータスコード: ${xhr.status})`,
          })
        }
      }
    }
    xhr.onerror = () => {
      return rejected({
        code: -9999,
        message: "サーバーとの通信に失敗しました。",
      })
    }
    xhr.send(base64string.split(",")[1])
  })
}

export const InputImageFileWithUpload = async (
  files: FileList,
): Promise<IUploadImage> => {
  const file = await InputImageErrorCheck(files).catch(e => Promise.reject(e))
  const base64image = await ImageTransform(file, MAXIMUM_DIMENSION)
  return await ImageUpload(base64image).catch(e => Promise.reject(e))
}

export const InputImageFile = async (
  files: FileList,
): Promise<UpdateUserInput["profileImage"]> => {
  const file = await InputImageErrorCheck(files).catch(e => Promise.reject(e))
  return {
    base64EncodedData: (await ImageTransform(file, MAXIMUM_DIMENSION)).split(
      ",",
    )[1],
    contentType: "image/jpeg",
  }
}
